<div class="tw-flex tw-flex-col tw-h-full tw-overflow-hidden">
    <div class="filter-chip-container tw-flex tw-flex-col tw-p-4">
        <form autocomplete="off" [formGroup]="filterForm">
            @if (isSmallScreen()) {
                <mat-expansion-panel class="tw-bg-transparent tw-shadow-none" [hideToggle]="false">
                    <mat-expansion-panel-header class="tw-px-1 tw-fle tw-items-center tw-text-center">
                        <mat-panel-title>
                            <!-- <mat-icon class="tw-flex-none tw-mr-2">filter_list</mat-icon> -->
                            <span>{{ filterService.getSummary() }}</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="tw-grid tw-grid-cols-1 tw-gap-4 tw-pt-2">
                        <ng-container *ngTemplateOutlet="filterFields" />
                    </div>
                </mat-expansion-panel>
            } @else {
                <div class="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
                    <ng-container *ngTemplateOutlet="filterFields" />
                </div>
            }

            <ng-template #filterFields>
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label translate>STOCK.TOPBAR_STOCK.MOVEMENT_TYPE</mat-label>
                    <mat-select formControlName="movement_type">
                        @for (type of filterService.movementTypes; track type.value) {
                            <mat-option [value]="type.value">{{ type.label | translate }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field subscriptSizing="dynamic">
                    <mat-label translate>STOCK.TOPBAR_STOCK.STOCK_LOCATION</mat-label>
                    <mat-select formControlName="stock_location_id">
                        @for (location of filterService.stockLocations(); track location.id) {
                            <mat-option [value]="location.id">{{ location.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field subscriptSizing="dynamic">
                    <mat-label translate>STOCK.TOPBAR_STOCK.FILTER_FROM</mat-label>
                    <input matInput formControlName="date_from" [matDatepicker]="fromPicker"
                        [max]="filterService.date_to?.value">
                    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromPicker></mat-datepicker>
                    @if (filterService.date_from?.hasError('required')) {
                        <mat-error>{{ 'NG_MESSAGES.REQUIRED_FIELD' | translate }}</mat-error>
                    } @else if (filterService.date_from?.invalid) {
                        <mat-error>{{ 'NG_MESSAGES.INVALID_VALUE' | translate }}</mat-error>
                    }
                </mat-form-field>

                <mat-form-field subscriptSizing="dynamic">
                    <mat-label translate>STOCK.TOPBAR_STOCK.FILTER_TO</mat-label>
                    <input matInput formControlName="date_to" [matDatepicker]="toPicker"
                        [min]="filterService.date_from?.value">
                    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
                    <mat-datepicker #toPicker></mat-datepicker>
                    @if (filterService.date_to?.hasError('required')) {
                        <mat-error>{{ 'NG_MESSAGES.REQUIRED_FIELD' | translate }}</mat-error>
                    } @else if (filterService.date_to?.invalid) {
                        <mat-error>{{ 'NG_MESSAGES.INVALID_VALUE' | translate }}</mat-error>
                    }
                </mat-form-field>
            </ng-template>
        </form>
    </div>

    <div class="tw-flex-1 tw-min-h-0 tw-relative">
        @if (!filterService.searchText()) {
            <app-grid-server-side
                #stockMovemnetsGridComponent
                class="master-detail-grid"
                feature="stock_movements"
                (rowClicked)="rowClicked($event)"
                [cacheBlockSize]="query.per_page"
                [datasource]="datasource"
                [hidden]="!gridPath"
                [fixedButtons]="fixedButtons"
                [tableData]="tableData[0]"
                (filterChangedEmitter)="onFilterChangedEmitter($event)"
                [exportFormatterOptions]="exportFormatterOptions"
                (clickableAction)="actions($event)"
                [masterDetail]="true"
                [detailRowAutoHeight]="false"
                idField="__batch_id"
                [initialState]="batchesInitialState"
                [suppressNoRowsOverlay]="true"
                [getRowHeight]="getRowHeight"
                (rowGroupOpened)="onRowGroupOpened($event)"
                [detailCellRendererParams]="detailCellRendererParams"
            ></app-grid-server-side>
        } @else {
            <app-grid-server-side
                #stockMovementsSearchGridComponent
                feature="stock_movements_search"
                (rowClicked)="searchRowClicked($event)"
                [cacheBlockSize]="query.per_page"
                [datasource]="searchDatasource"
                [hidden]="!gridPath"
                [fixedButtons]="searchFixedButtons"
                [tableData]="searchTableData"
                [exportFormatterOptions]="exportFormatterOptions"
                [suppressNoRowsOverlay]="true"
                [initialState]="searchInitialState"
                (filterChangedEmitter)="onSearchFilterChanged($event)"
            ></app-grid-server-side>
        }

        @if (noResults) {
            <div class="no-results-placeholder">
                <img src="assets/images/stock/stock-no-movements.png" alt="" />
                <div class="no-results-message">{{ 'STOCK.MOVEMENTS.NO_MOVEMENT_FOUND' | translate }}</div>
            </div>
        }
    </div>

    <app-barcode [hideButton]="true" (onSubmitBarcode)="onBarcodeScanned($event)"></app-barcode>
</div>